
<template>
  <!--已禁言用户-->
  <div>
    <div class="advanced-form">
      <div class="card">
        <div class="card-head">
          <h3>{{`${$route.query.name}（${$route.query.type}）`}}</h3>
        </div>
        <div class="card-body">
          <x-tabula
            apiOrigin="PHP"
            ref="table"
            :excludeResetKey="['status']"
            :dataSource="dataSource"
            :columns="columns"
            rowKey="chat_user_id"
            :searchList="searchList"
            :rowOptList="rowOptList"
            :listApi="listApi"
            :searchParams.sync="searchParams"
            :deleteParam="deleteParam"
            :rowSelection="false"
          >
          </x-tabula>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'banned',
  data () {
    return {
      chatGroupId: '',
      visible: false,
      btnLoading: {loading: false},
      searchParams: {
        keywords: undefined,
        user_type: undefined,
        create_date: undefined,
        status: 0
      },
      searchList: [
        { props: ['keywords'], placeholder: '用户昵称、群内昵称', options: [], inputType: 'input' },
        { props: ['user_type'], placeholder: '用户类型', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }
      ],
      rowOptList: [
        { text: '解禁', handle: this.liberateMember, key: 'cancel' }
      ],
      columns: [
        { title: '昵称', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '群内昵称', dataIndex: 'group_nick_name', align: 'left', width: '' },
        { title: '用户类型', dataIndex: 'user_type_desc', align: 'left', width: '' },
        { title: '群内状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '进群时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: `/chat/group/user/${this.$route.query.id}`,
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '',
        param: { pk_key: '', pk_val: '' },
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.chatGroupId = this.$route.query.id;
    this.getSelect();
  },
  methods: {
    /** 获取下拉 */
    getSelect () {
      this._get({
        url: '/chat/group/selectlist',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data.user_type;
      });
    },
    /** 解禁用户 */
    liberateMember (row) {
      this.$confirm({
        title: '确定解禁该用户？',
        centered: true,
        onOk: () => {
          this._post({
            url: '/chat/group/user/change',
            params: {
              chat_group_id: this.chatGroupId,
              chat_user_id: row.chat_user_id,
              status: 1
            }
          }).then(({data}) => {
            this.$message.success('解禁成功');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
